(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-intro-draggable-icons"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.getElementById('drift-{{ section.id }}');
    if(!root) return;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints>0;
    function clamp(v, min, max){return Math.min(Math.max(v, min), max)}

    root.querySelectorAll('.drift-icon').forEach(el=>{
      let active=false, startX=0, startY=0, baseX=0, baseY=0;
      const bounds = ()=>root.getBoundingClientRect();

      const down = (e)=>{
        if(isTouch && window.innerWidth<768) return; // UX: limita drag en móvil
        active = true;
        const pt = (e.touches? e.touches[0]: e);
        startX = pt.clientX; startY = pt.clientY;
        baseX = parseFloat(getComputedStyle(el).getPropertyValue('--x'))||10;
        baseY = parseFloat(getComputedStyle(el).getPropertyValue('--y'))||10;
        el.classList.add('dragging');
      };
      const move = (e)=>{
        if(!active) return;
        const rect = bounds();
        const pt = (e.touches? e.touches[0]: e);
        const dx = (pt.clientX-startX)/rect.width*100;
        const dy = (pt.clientY-startY)/rect.height*100;
        el.style.setProperty('--x', clamp(baseX+dx, -10, 110));
        el.style.setProperty('--y', clamp(baseY+dy, -10, 110));
      };
      const up = ()=>{ active=false; el.classList.remove('dragging'); };
      el.addEventListener('mousedown', down);  el.addEventListener('touchstart', down, {passive:true});
      window.addEventListener('mousemove', move, {passive:false});
      window.addEventListener('touchmove', move, {passive:false});
      window.addEventListener('mouseup', up);   window.addEventListener('touchend', up);
    });
  })();
  
  } catch(e) { console.error(e); }
})();
})();
